export const menuData = [
  { title: "Home", link: "/" },
  { title: "Services", link: "/services" },
  { title: "About", link: "/about" },
  { title: "Videos", link: "/videos" },
  { title: "Contact", link: "/contact" },
]
